<template>
    <a-layout-footer :style="{width: '100%',display:'none'}">
        Footer
    </a-layout-footer>
</template>

<script>
export default {
    name: "footer_bar"
}
</script>

<style scoped>
#components-main-layout .ant-layout-footer {
    background: #7dbcea;
    color: #fff;
}
#components-main-layout .ant-layout-footer {
    line-height: 1.5;
}
</style>